export const FeatureFlags = {
  /**
   * ISO Commission Panel — deal/draw commission sliders, adjusted sell-rate
   * calculations (recalculateWithCommissions, calculateNominalAPR), and modified
   * accept-offer payloads (factor, upsellActivation, upsellDraw overrides).
   *
   * Set to true only when the panel is approved for the target environment.
   * When false, ISO-facing pricing pages load and display offers normally but
   * with no commission overrides — behaviour is identical to the merchant view.
   *
   * To enable: change this value to true and redeploy.
   */
  isoCommissionPanelEnabled: true,
} as const;
